import { Dropdown } from "primereact/dropdown";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";

import {
  labelAdmin,
  labelUser,
  labelEditor,
  erroreCampoObbligatorio,
  inputRole,
} from "_constants";
import { PrimeIcons } from "primereact/api";
import { useAppSelector } from "store/store";

export const SelectUserRole = ({
  control,
  getValues,
  required = false,
}: any) => {
  const currentUserRole = useAppSelector((state) => state.profiloSlice.role);
  const stato =
    currentUserRole === "SUPERADMIN"
      ? [
          { name: labelAdmin, value: 0 },
          { name: labelUser, value: 1 },
          { name: labelEditor, value: 2 },
        ]
      : [
          { name: labelUser, value: 1 },
          { name: labelEditor, value: 2 },
        ];

  return (
    <Controller
      name="role"
      control={control}
      rules={{ required: erroreCampoObbligatorio }}
      render={({ field, fieldState: { error } }) => (
        <div className="flex-container column">
          <Dropdown
            dataKey="value"
            id={field.name}
            {...field}
            optionValue="value"
            options={stato}
            optionLabel="name"
            placeholder={`${inputRole}${required ? "*" : ""}`}
            className={`${classNames({
              "p-invalid": error,
            })} width-100`}
            clearIcon={PrimeIcons.TIMES}
            showClear={parseFloat(getValues("role")) > -1 ? true : false}
          />
          {error && (
            <small className="p-error margin-bottom-4">{error.message}</small>
          )}
        </div>
      )}
    />
  );
};
